import type { ComponentPropsWithRef } from "react";

export const ErrorIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg {...props} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 17.1113C14.9813 17.1113 15.7772 17.911 15.7773 18.8887C15.7773 19.8664 14.9813 20.666 14 20.666C13.0187 20.666 12.2227 19.8663 12.2227 18.8887C12.2228 17.9112 13.0188 17.1114 14 17.1113Z"
      fill={props.color ?? "currentColor"}
    />
    <path
      d="M13.9981 7.33398C14.7341 7.33416 15.3318 7.93002 15.3321 8.66601V14C15.332 14.7362 14.7343 15.3338 13.9981 15.334C13.2617 15.334 12.6642 14.7363 12.6641 14V8.66601C12.6644 7.92991 13.2619 7.33398 13.9981 7.33398Z"
      fill={props.color ?? "currentColor"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0019 0.666016C21.3657 0.666016 27.3359 6.6362 27.3359 14C27.3359 21.3638 21.3657 27.334 14.0019 27.334C6.63815 27.334 0.667969 21.3638 0.667969 14C0.667969 6.6362 6.63815 0.666016 14.0019 0.666016ZM14.0019 3.33398C8.11095 3.33398 3.33593 8.109 3.33593 14C3.33593 19.891 8.11095 24.666 14.0019 24.666C19.8929 24.666 24.6679 19.891 24.6679 14C24.6679 8.109 19.8929 3.33398 14.0019 3.33398Z"
      fill={props.color ?? "currentColor"}
    />
  </svg>
);
